// src/api/hooks/usePreventedLoss.js — Canon v8.3
// /api/antiloss/prevented returns: { ok, prevented_total }
// /api/antiloss/actions  returns:  { ok, items: [...] }

import { useEffect, useState } from "react";
import { workerClient }        from "../workerClient";
import { formatMoney }         from "../mappers/formatMoney";
import { buildEngineStory }    from "../mappers/buildEngineStory";

export function usePreventedLoss() {
  const [data, setData] = useState({
    total30d:     "—",
    total30dRaw:  0,
    delta:        null,
    actionsCount: 0,
    lastActionAt: null,
    story:        null,
    decision:     null,   // Change 4: {risk_status, action, confidence, reasons[], mode}
    loading:      true,
    error:        false,
  });

  useEffect(() => {
    let mounted = true;

    Promise.all([
      workerClient("/api/antiloss/prevented"),
      workerClient("/api/antiloss/actions"),
      workerClient("/api/engine/status").catch(() => null),  // Change 4: decision data
    ])
      .then(([prevented, actions, engineStatus]) => {
        if (!mounted) return;

        const total  = Number(prevented?.prevented_total) || 0;
        const items  = Array.isArray(actions?.items) ? actions.items : [];
        const count  = items.length;
        const lastAt = items.length > 0 ? items[0].timestamp : null;

        const story = total > 0
          ? buildEngineStory(
              { engineOnline: true, lastRiskEvent: null },
              { total30d: total }
            )
          : "✓ No risk events in last 30 days · Budget stable";

        // Change 4: берём последний decision из engine/status
        const campaigns = engineStatus?.campaigns ?? [];
        const lastDecision = campaigns.length > 0 ? {
          risk_status: campaigns[0].risk_status,
          action:      campaigns[0].action,
          confidence:  campaigns[0].confidence,
          mode:        campaigns[0].mode,
          reasons:     [],  // reasons пока в timeline, не в status
        } : null;

        setData({
          total30d:     total > 0 ? formatMoney(total) : "€ 0",
          total30dRaw:  total,
          delta:        null,
          actionsCount: count,
          lastActionAt: lastAt,
          story,
          decision:     lastDecision,
          loading:      false,
          error:        false,
        });
      })
      .catch(() => {
        if (!mounted) return;
        setData({
          total30d:     "—",
          total30dRaw:  0,
          delta:        null,
          actionsCount: 0,
          lastActionAt: null,
          story:        null,
          decision:     null,
          loading:      false,
          error:        true,
        });
      });

    return () => { mounted = false; };
  }, []);

  return data;
}